import LocalStorage, { Keys } from '../Storage/LocalStorage'

const FEATURES = {
  CHARGE_CODE_ENTRY: 'ChargeCodeEntry'
}

function hasFeature(featureName) {
  try {
    const rolesRaw = LocalStorage.get(Keys.ROLES)
    const roles = Array.isArray(rolesRaw) ? rolesRaw : (typeof rolesRaw === 'string' ? JSON.parse(rolesRaw || '[]') : [])
    return roles.some((role) => role.features && role.features.some((f) => f.name === featureName))
  } catch {
    return false
  }
}

/**
 * Returns true when charge code should be required (e.g. for Library export).
 * Based on user roles from the backend: true if the user's role has the ChargeCodeEntry feature.
 */
export function isChargeCodeRequired() {
  return hasFeature(FEATURES.CHARGE_CODE_ENTRY)
}
